// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"440":"00b2d172","484":"a6ef2c03","551":"2ed5c09f"}[chunkId] + ".chunk.js";
};